import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

// Fallback category for a question that needs the classify/follow-up engine
// but doesn't cleanly match any of the specific Section B topic groups —
// universal narrative-completeness guidance and the cross-cutting hard
// barrier only, no topic-specific probing focus or escalation facts.
export const general: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.GENERAL,
  label: "General",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "what happened",
    "when it happened",
    "how it was resolved",
    "what the candidate learned",
  ],
  followUpTriggers: [
    "the answer is vague about what happened or how it was resolved",
    "the timeline is unclear",
  ],
  hardBarrierFacts: [
    "anything involving violence, weapons, or minors, regardless of how it was resolved; dishonesty only when it was for gain, against an employer, institution or the law, or harmed someone",
  ],
};
